import { startOfMonth, subMonths, endOfMonth, addDays, startOfDay, subDays, endOfDay, getHours, getMinutes, startOfYear, subYears, differenceInDays, startOfWeek, endOfWeek, subWeeks } from 'date-fns';
import React, { createContext, useReducer, useContext, useEffect, useMemo, useCallback } from 'react';
import { zoneToData, getTimeZone } from 'src/config/timezone';
import { useLocation } from 'react-router-dom';
import { idb } from 'src/utils/idb';
import { useCommonContext } from 'src/contexts/CommonContext';
import moment from 'moment-timezone';

// Initial state for the context

// console.log("checkData", addDays(new Date(), 0))
// console.log("checkDataTz", new Date(zoneToData(addDays(new Date(), 0))))

const hourFilterList = [
  { label: '12 AM - 1 AM', value: '00:00:00', checked: 1 },
  { label: '01 AM - 2 AM', value: '01:00:00', checked: 1 },
  { label: '02 AM - 3 AM', value: '02:00:00', checked: 1 },
  { label: '03 AM - 4 AM', value: '03:00:00', checked: 1 },
  { label: '04 AM - 5 AM', value: '04:00:00', checked: 1 },
  { label: '05 AM - 6 AM', value: '05:00:00', checked: 1 },
  { label: '06 AM - 7 AM', value: '06:00:00', checked: 1 },
  { label: '07 AM - 8 AM', value: '07:00:00', checked: 1 },
  { label: '08 AM - 9 AM', value: '08:00:00', checked: 1 },
  { label: '09 AM - 10 AM', value: '09:00:00', checked: 1 },
  { label: '10 AM - 11 AM', value: '10:00:00', checked: 1 },
  { label: '11 AM - 12 PM', value: '11:00:00', checked: 1 },
  { label: '12 PM - 1 PM', value: '12:00:00', checked: 1 },
  { label: '01 PM - 2 PM', value: '13:00:00', checked: 1 },
  { label: '02 PM - 3 PM', value: '14:00:00', checked: 1 },
  { label: '03 PM - 4 PM', value: '15:00:00', checked: 1 },
  { label: '04 PM - 5 PM', value: '16:00:00', checked: 1 },
  { label: '05 PM - 6 PM', value: '17:00:00', checked: 1 },
  { label: '06 PM - 7 PM', value: '18:00:00', checked: 1 },
  { label: '07 PM - 8 PM', value: '19:00:00', checked: 1 },
  { label: '08 PM - 9 PM', value: '20:00:00', checked: 1 },
  { label: '09 PM - 10 PM', value: '21:00:00', checked: 1 },
  { label: '10 PM - 11 PM', value: '22:00:00', checked: 1 },
  { label: '11 PM - 12 PM', value: '23:00:00', checked: 1 },
];


const authToken = JSON.parse(localStorage.getItem('User')) || {};
const isDemoLogin = process.env.REACT_APP_DEMO_EMAIL.indexOf(authToken?.email) > -1

export const getNewPayloadDateRange = (pathName = '', sqpEndDate = null) => {
  const pathRef = String(pathName != '' ? pathName : window.location.href)
  
  // Calculate date ranges for hector-registration
  if (pathRef.indexOf('hector-registration') > -1) {
    const mainStartDate = startOfYear(new Date(2022, 0, 1));
    const mainEndDate = new Date();
    const daysDifference = differenceInDays(mainEndDate, mainStartDate);
    const comparisonEndDate = subDays(mainStartDate, 1); // Dec 31, 2021
    const comparisonStartDate = subDays(comparisonEndDate, daysDifference);
    
    return {
      startDate: new Date(zoneToData(mainStartDate)),
      endDate: new Date(zoneToData(mainEndDate)),
      pastStartDate: new Date(zoneToData(comparisonStartDate)),
      pastEndDate: new Date(zoneToData(comparisonEndDate)),
      key: 'Lifetime',
      compare: true
    };
  }
  
  return isDemoLogin && (pathRef.indexOf('snapshot') > -1 || pathRef.indexOf('master-overview') > -1) ? {
    startDate: new Date(zoneToData(subDays(new Date(), 30))),
    endDate: new Date(zoneToData(subDays(new Date(), 1))),
    pastStartDate: new Date(zoneToData(subDays(new Date(), 60))),
    pastEndDate: new Date(zoneToData(subDays(new Date(), 31))),
    key: 'Last 30 Days',
    compare: true
  } : pathRef.indexOf('flipkart-snapshot') > -1 ? {
    startDate: new Date(zoneToData(startOfDay(subDays(new Date(), 7)))),
    endDate: new Date(zoneToData(addDays(new Date(), -1))),
    pastStartDate: new Date(zoneToData(startOfDay(subDays(new Date(), 14)))),
    pastEndDate: new Date(zoneToData(endOfDay(subDays(new Date(), 8)))),
    key: 'Last 7 Days',
    compare: true
  } : pathRef.indexOf('snapshot') > -1 ? {
    startDate: new Date(zoneToData(addDays(new Date(), -1))),
    endDate: new Date(zoneToData(addDays(new Date(), -1))),
    pastStartDate: new Date(zoneToData(addDays(new Date(), -2))),
    pastEndDate: new Date(zoneToData(addDays(new Date(), -2))),
    key: 'Yesterday',
    compare: true
  } : pathRef.indexOf('master-overview') > -1 || pathRef.indexOf('sov') > -1 ? {
    startDate: new Date(zoneToData(startOfDay(subDays(new Date(), 7)))),
    endDate: new Date(zoneToData(addDays(new Date(), -1))),
    pastStartDate: new Date(zoneToData(startOfDay(subDays(new Date(), 14)))),
    pastEndDate: new Date(zoneToData(endOfDay(subDays(new Date(), 8)))),
    key: 'Last 7 Days',
    compare: true
  } : pathRef.indexOf('/amazon-dayparting-scheduler') > -1 || pathRef.indexOf('/amazon-dayparting-performance') > -1 || pathRef.indexOf('/amazon-dsp-dayparting-scheduler') > -1 || pathRef.indexOf('/amazon-dsp-dayparting-performance') > -1? {
    startDate: new Date(zoneToData(subDays(new Date(), 30))),
    endDate: new Date(zoneToData(subDays(new Date(), 1))),
    pastStartDate: new Date(zoneToData(subDays(new Date(), 60))),
    pastEndDate: new Date(zoneToData(subDays(new Date(), 31))),
    key: 'Last 30 Days',
    compare: 1
  }: pathRef.indexOf('amazon-dsp/marketing-stream') > -1 ? {
    startDate: new Date(zoneToData(new Date())),
    endDate: new Date(zoneToData(new Date())),
    pastStartDate: new Date(zoneToData(subDays(new Date(), 1))),
    pastEndDate: new Date(zoneToData(subDays(new Date(), 1))),
    key: 'Today',
    compare: true
  } : pathRef.indexOf('/amazon-dsp/reports') > -1 ? {
    startDate:  new Date(zoneToData(subDays(new Date(), 7))),
    endDate:  new Date(zoneToData(subDays(new Date(), 1))),
    pastStartDate:  new Date(zoneToData(subDays(new Date(), 14))),
    pastEndDate:  new Date(zoneToData(subDays(new Date(), 8))),
    key: 'Last 7 Days',
    compare: true
  } : pathRef.indexOf('amazon/marketing-stream') > -1 || pathRef.indexOf('dsp-invoice-history') > -1 ? {
    startDate: new Date(zoneToData(new Date())),
    endDate: new Date(zoneToData(new Date())),
    pastStartDate: new Date(zoneToData(subDays(new Date(), 1))),
    pastEndDate: new Date(zoneToData(subDays(new Date(), 1))),
    key: 'Today',
    compare: true
  } : pathRef.indexOf('amazon/search-query-performance') > -1 ? (() => {
    const weeksToSubtract = 12;
    
    // Use sqp_end_date from database if available, otherwise calculate last complete Saturday
    // Always use the minimum of: database end date OR last complete Saturday in profile timezone
    // This ensures users see data only till their account's timezone's last complete week
    let endDate;
    
    // Get profile timezone from localStorage (account timezone, not system timezone)
    const profileTimezone = getTimeZone();
    
    // Calculate last complete Saturday in profile timezone
    // Get current date/time in profile timezone
    const nowInProfileTz = moment().tz(profileTimezone);
    const currentDayOfWeek = nowInProfileTz.day(); // 0..6 (Sun..Sat)
    
    let lastCompleteSaturdayInProfileTz;
    if (currentDayOfWeek === 6) {
      // If today is Saturday, the last complete Saturday is 7 days ago
      lastCompleteSaturdayInProfileTz = nowInProfileTz.clone().subtract(7, 'days');
    } else {
      // For any other day, find the most recent Saturday
      lastCompleteSaturdayInProfileTz = nowInProfileTz.clone().subtract(currentDayOfWeek + 1, 'days');
    }
    
    // Ensure it's the end of week (Saturday) in profile timezone
    // Get the date components from the moment object to create a Date object
    // This ensures we're working with the correct date in profile timezone
    const saturdayDate = lastCompleteSaturdayInProfileTz.clone().day(6); // Set to Saturday of that week
    const saturdayDateString = saturdayDate.format('YYYY-MM-DD');
    const [year, month, day] = saturdayDateString.split('-').map(Number);
    const lastCompleteSaturday = new Date(year, month - 1, day); // month is 0-indexed
    
    if (sqpEndDate && sqpEndDate instanceof Date && !isNaN(sqpEndDate.getTime())) {
      // Convert database end date to profile timezone and ensure it's the end of week (Saturday)
      const dateInProfileTz = moment(sqpEndDate).tz(profileTimezone);
      // Get Saturday of that week in profile timezone
      const saturdayInProfileTz = dateInProfileTz.clone().day(6);
      const saturdayDateString = saturdayInProfileTz.format('YYYY-MM-DD');
      const [year, month, day] = saturdayDateString.split('-').map(Number);
      const dbEndDateNormalized = new Date(year, month - 1, day); // month is 0-indexed
      
      // Use the minimum of database date or profile's last complete Saturday
      // This ensures users don't see future dates beyond their account's timezone's last complete week
      endDate = dbEndDateNormalized < lastCompleteSaturday ? dbEndDateNormalized : lastCompleteSaturday;
    } else {
      // Fallback: Use calculated last complete Saturday
      endDate = lastCompleteSaturday;
    }

    // Main period (Sun-Sat): end = Saturday, start = Sunday (ensures full weeks)
    const startDate = startOfWeek(subWeeks(endDate, weeksToSubtract - 1), { weekStartsOn: 0 });

    // Comparison period: previous same number of weeks
    const pastEndDate = subDays(startDate, 1);
    const pastStartDate = startOfWeek(subWeeks(pastEndDate, weeksToSubtract - 1), { weekStartsOn: 0 });

    // Dates already computed in data timezone space; avoid double zone conversion
    return {
      startDate: new Date(startDate),
      endDate: new Date(endDate),
      pastStartDate: new Date(pastStartDate),
      pastEndDate: new Date(pastEndDate),
      key: 'Last 12 Weeks',
    };
  })() : pathRef.indexOf('summary/zepto') > -1 || pathRef.indexOf('summary/bigbasket') > -1 ? {
    startDate: new Date(zoneToData(subDays(new Date(), 30))),
    endDate: new Date(zoneToData(subDays(new Date(), 1))),
    pastStartDate: new Date(zoneToData(subDays(new Date(), 60))),
    pastEndDate: new Date(zoneToData(subDays(new Date(), 31))),
    key: 'Last 30 Days',
  } : pathRef.indexOf('view-logs') > -1 || pathRef.indexOf('amazon-dayparting-schedule-log') > -1 ? {
    startDate: new Date(zoneToData(subDays(new Date(), 29))),
    endDate: new Date(zoneToData(new Date())),
    pastStartDate: new Date(zoneToData(subDays(new Date(), 59))),
    pastEndDate: new Date(zoneToData(subDays(new Date(), 30))),
    key: 'Till Date',
    compare: true
  } : {
    startDate: new Date(zoneToData(subDays(new Date(), 30))),
    endDate: new Date(zoneToData(subDays(new Date(), 1))),
    pastStartDate: new Date(zoneToData(subDays(new Date(), 60))),
    pastEndDate: new Date(zoneToData(subDays(new Date(), 31))),
    key: 'Last 30 Days',
    compare: true
  }
}

const getRangesDefault = {
  'Last 30 Days': {
    startDate: new Date(zoneToData(subDays(new Date(), 30))),
    endDate: new Date(zoneToData(subDays(new Date(), 1))),
    pastStartDate: new Date(zoneToData(subDays(new Date(), 60))),
    pastEndDate: new Date(zoneToData(subDays(new Date(), 31))),
    key: 'Last 30 Days'
  },
  'Till Date': {
    startDate: new Date(zoneToData(subDays(new Date(), 29))),
    endDate: new Date(zoneToData(new Date())),
    pastStartDate: new Date(zoneToData(subDays(new Date(), 59))),
    pastEndDate: new Date(zoneToData(subDays(new Date(), 30))),
    key: 'Till Date'
  },
  'Today': {
    startDate: new Date(zoneToData(new Date())),
    endDate: new Date(zoneToData(new Date())),
    pastStartDate: new Date(zoneToData(subDays(new Date(), 1))),
    pastEndDate: new Date(zoneToData(subDays(new Date(), 1))),
    key: 'Today'
  },
  'Last 7 Days': {
    startDate:  new Date(zoneToData(subDays(new Date(), 7))),
    endDate:  new Date(zoneToData(subDays(new Date(), 1))),
    pastStartDate:  new Date(zoneToData(subDays(new Date(), 14))),
    pastEndDate:  new Date(zoneToData(subDays(new Date(), 8))),
    key: 'Last 7 Days'
  },
  'Yesterday': {
    startDate: new Date(zoneToData(addDays(new Date(), -1))),
    endDate: new Date(zoneToData(addDays(new Date(), -1))),
    pastStartDate: new Date(zoneToData(addDays(new Date(), -2))),
    pastEndDate: new Date(zoneToData(addDays(new Date(), -2))),
    key: 'Yesterday'
  },
}

const getDefaults = async (pathRef = '', sqpEndDate = null) => {
  // const localDatePayload = JSON.parse(localStorage.getItem(`--local-date-payload${String(window.location.pathname).replace(/\//g, '-')}`));
  const params = new URLSearchParams(window.location.search);
  const startDate = params.get('startDate') || null;
  const endDate = params.get('endDate') || null;
  const pastStartDate = params.get('pastStartDate');
  const pastEndDate = params.get('pastEndDate');
  const key = params.get('key') || null;
  const compare = params.get('compare');

  const indexDbPayload = await idb.getDateConfig(`DateRangeDB${String(window.location.pathname).replace(/\//g, '-')}`);

  if (key && startDate && endDate && Boolean(key) && Boolean(startDate) && Boolean(endDate)) return {
    key: key,
    startDate: new Date(startDate),
    endDate: new Date(endDate),
    pastStartDate: new Date(pastStartDate),
    pastEndDate: new Date(pastEndDate),
    compare: compare,
    ...(key && Boolean(key) && String(key).toLowerCase() != 'custom' && getRangesDefault[key] ? {
      startDate: new Date(getRangesDefault[key]?.startDate),
      endDate: new Date(getRangesDefault[key]?.endDate),
      pastStartDate: new Date(getRangesDefault[key]?.pastStartDate),
      pastEndDate: new Date(getRangesDefault[key]?.pastEndDate)
    } : {})
  }

  if(indexDbPayload?.key && indexDbPayload?.startDate && indexDbPayload?.endDate && Boolean(indexDbPayload?.key) && Boolean(indexDbPayload?.startDate) && Boolean(indexDbPayload?.endDate)) return { 
    key: indexDbPayload?.key,
    startDate: new Date(indexDbPayload?.startDate),
    endDate: new Date(indexDbPayload?.endDate),
    pastStartDate: new Date(indexDbPayload?.pastStartDate),
    pastEndDate: new Date(indexDbPayload?.pastEndDate),
    compare: indexDbPayload?.compare,
    ...(indexDbPayload?.key && Boolean(indexDbPayload?.key) && String(indexDbPayload?.key).toLowerCase() != 'custom' && getRangesDefault[indexDbPayload?.key] ? {
      startDate: new Date(getRangesDefault[indexDbPayload?.key]?.startDate),
      endDate: new Date(getRangesDefault[indexDbPayload?.key]?.endDate),
      pastStartDate: new Date(getRangesDefault[indexDbPayload?.key]?.pastStartDate),
      pastEndDate: new Date(getRangesDefault[indexDbPayload?.key]?.pastEndDate)
    } : {})
   }
  return getNewPayloadDateRange(pathRef, sqpEndDate)
}

const initialState = {
  dateRange: null,
  hourFilter: hourFilterList,
  crossFilters: [],
  availableColumns: [],
  availableTables: {},
  clearCrossFilters: false,
  applyCrossFilters: false,
  marketingStreamHour: null,
  marketingStreamHourLoading: false
}



// Define the reducer function
const reducer = (state, action) => {
  switch (action.type) {
    case 'UPDATE_DATE_RANGE':
      return { ...state, dateRange: action.payload };
    case 'UPDATE_SOV_FILTERS':
      return { ...state, filters: action.payload };
    case 'UPDATE_CROSS_FILTERS':
      return { ...state, crossFilters: action.payload };
    case 'CLEAR_CROSS_FILTERS':
      return { ...state, clearCrossFilters: action.payload };
    case 'APPLY_CROSS_FILTERS':
      return { ...state, applyCrossFilters: action.payload };
    case 'UPDATE_AVAILABLE_COLUMNS':
      return { ...state, availableColumns: action.payload };
    case 'UPDATE_AVAILABLE_TABLES':
      return { ...state, availableTables: action.payload };
    case 'UPDATE_CALENDAR_DATES':
      return { ...state, dateRange: action.payload };
    case 'UPDATE_HOURS_FILTER':
      return { ...state, HoursFilter: action.payload };
    case 'UPDATE_MARKETING_STREAM_HOUR':
      return { ...state, marketingStreamHour: action.payload };
    case 'MARKETING_STREAM_HOUR_LOADING':
      return { ...state, marketingStreamHourLoading: action.payload };
    case 'SET_DEFAULT_DATE_RANGE':
      return { ...state, dateRange: action.payload };
    default:
      return state;
  }
};

// Create the context
const PayloadContext = createContext();

// Create a custom hook to use the context
const usePayloadContext = () => {
  const context = useContext(PayloadContext);
  if (!context) {
    throw new Error('usePayloadContext must be used within a PayloadProvider');
  }
  return context;
};

// Create the provider component
const PayloadProvider = ({ children }) => {
  
  const location = useLocation();
  const { commonState } = useCommonContext();

  const [payloadState, payloadDispatch] = useReducer(reducer, initialState);

  const isDaypartingLogPage = useMemo(() => {
    let urlParts = location.pathname.split('/');
    const slotType = urlParts[2] || undefined; // ':ruleType'
    const slotId = urlParts[3] || undefined;   // ':slotId'
    const slotAction = urlParts[4] || undefined; // 'update|revert'
    return location.pathname?.includes('amazon-dayparting-schedule-log') &&
      Boolean(slotType) && Boolean(slotId) && Boolean(slotAction);
  }, [location.pathname]);


  const isRuleBasedLogPage = useMemo(() => {
    let urlParts = location.pathname.split('/');
    const typeRule = urlParts[2] || undefined; // ':type_rule'
    const typeRuleId = urlParts[4] || undefined; // ':type_rule_id'  
    const checkId = urlParts[6] || undefined; // ':check_id'
    return location.pathname?.includes('view-logs-notifications') &&
      Boolean(typeRule) && Boolean(typeRuleId) && Boolean(checkId);
  }, [location.pathname]);

  const isDaypartingNotificationDetails = useMemo(() => {
    let urlParts = location.pathname.split('/');
    const slotType = urlParts[2] || undefined; // ':ruleType'
    const slotId = urlParts[3] || undefined;   // ':slotId'
    const slotAction = urlParts[4] || undefined; // 'update|revert'
    const notificationItem = JSON.parse(localStorage.getItem(`dayParting-${slotType}-${slotId}-${slotAction}`));
    return notificationItem;
  }, [location.pathname]);

  const isRuleBasedNotificationDetails = useMemo(() => {
    let urlParts = location.pathname.split('/');
    const typeRule = urlParts[2] || undefined; // ':type_rule'
    const typeRuleId = urlParts[4] || undefined; // ':type_rule_id'  
    const checkId = urlParts[6] || undefined; // ':check_id'
    console.log("isRuleBased-typeRule", {typeRule, typeRuleId, checkId})
    const notificationItem = JSON.parse(localStorage.getItem(`ruleBasedAutomation-${typeRule}-${typeRuleId}-${checkId}`));
    return notificationItem;
  }, [location.pathname]);

  useEffect(() => {
    const loadDefaults = async () => {
      // Get sqp_end_date from CommonContext if available
      const sqpEndDate = commonState?.dateInfo?.sqp_end_date 
        ? new Date(commonState.dateInfo.sqp_end_date) 
        : null;
      const defaultDateRange = await getDefaults('', sqpEndDate);
      payloadDispatch({ type: 'SET_DEFAULT_DATE_RANGE', payload: defaultDateRange });
    };
  
    // Only call if we're not on a notification/log page
    if (!isDaypartingLogPage && !isRuleBasedLogPage) {
      loadDefaults();
    }
  }, [commonState?.dateInfo?.sqp_end_date]);

  const getDefaultsNotification = useCallback((prop) => {
    const payload = prop === 'isDaypartingLogPage'
      ? isDaypartingNotificationDetails
      : isRuleBasedNotificationDetails;
    return {
      key: 'custom',
      startDate: new Date(zoneToData(payload?.createdAt)),
      endDate: new Date(zoneToData(payload?.createdAt)),
      pastStartDate: new Date(zoneToData(payload?.createdAt)),
      pastEndDate: new Date(zoneToData(payload?.createdAt)),
      compare: false,
    };
  }, [isDaypartingNotificationDetails, isRuleBasedNotificationDetails]);

  useEffect(() => {
    const updateDateRangeBasedOnPath = async (pathName) => {
      if(location.pathname.indexOf('/amazon-dsp/reports') > -1 || location.pathname.indexOf('/amazon-dsp/marketing-stream') > -1) return;
      try {
        // Get sqp_end_date from CommonContext if available
        const sqpEndDate = commonState?.dateInfo?.sqp_end_date 
          ? new Date(commonState.dateInfo.sqp_end_date) 
          : null;
        const newDateRange = isDaypartingLogPage
          ? getDefaultsNotification('isDaypartingLogPage')
          : isRuleBasedLogPage
            ? getDefaultsNotification('isRuleBasedLogPage')
            : await getDefaults(pathName, sqpEndDate);
        payloadDispatch({ type: 'UPDATE_DATE_RANGE', payload: newDateRange });
      } catch (error) {
        console.error('Error loading date range:', error);
        payloadDispatch({
          type: 'UPDATE_DATE_RANGE',
          payload: getRangesDefault['Last 30 Days']
        });
      }
    };
    updateDateRangeBasedOnPath(location.pathname);
  }, [location.pathname, isDaypartingLogPage, isDaypartingNotificationDetails, isRuleBasedLogPage, isRuleBasedNotificationDetails, commonState?.dateInfo?.sqp_end_date]);
  
  return (
    <PayloadContext.Provider value={{ payloadState, payloadDispatch }}>
      {children}
    </PayloadContext.Provider>
  );
};

export { PayloadProvider, usePayloadContext };

